export const heroOne = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Founded in 2019',
	},
	headline: "We've been in business for well over 3 years",
	description: 'We have taught and made countless projects some of them have well maintained job in various feilds.',
	buttonLabel: 'More Info',
	imgStart: 'start',
	img: './assets/svg/done.webp',
	start: 'true',
};

export const heroTwo = {
	reverse: false,
	inverse: false,
	topLine: {
		text: 'Feedback',
	},
	headline: 'The best practices',
	description: 'Our clients have had the best experience working with us.',
	buttonLabel: 'Projects',

	linkTo: '/more',
	imgStart: 'start',
	img: './assets/svg/project.jpg',
	start: 'true',
};

export const heroThree = {
	reverse: true,
	inverse: true,
	topLine: {
		text: 'Provides Best Learning Experience',
		
	},
	headline: 'Why us? ',
	description:
		'Our 3 year experience have allowed us to use the most reliable in such short span and with the acheivment the clients have made.',
	buttonLabel: 'Information',

	linkTo: '/download',
	imgStart: '',
	img: './assets/svg/team.jpg',
	start: 'true',
};
